/*
 * @description:登录页面路由集合
 * @Author: renjie.huang
 * @Date: 2017/12/5
 * @LastEditors: xiaoping.zhang
 * @LastEditTime: 2019-08-29 16:24:54
 */
import loginRoute from './routes/login'
import SubAccountLoginRoute from './routes/SubAccountLogin'
import registerRoute from './routes/register'
import activeRoute from './routes/active'
import activeResultRoute from './routes/activeResult'
import retrieve from './routes/retrieve'
import retrieveInput from './routes/retrieveInput'
import retrieveByMobile from './routes/retrieve/retrieveByMobile'  //找回密码
import verifyPhoneNumber from './routes/retrieve/verifyPhoneNumber'
import resetPassword from './routes/retrieve/resetPassword'
import loginRouteOld from './routes/login-old'
import OAuth from './routes/oauth'
import registerRouteOld from './routes/register-old'
import Logout from './routes/logout';
import Guide from './routes/guide'
import ChangePwdTermly from './routes/changePwdTermly'
import activeSubaccount from './routes/activeSubaccount'  // 进入页面方法 activeSubaccount?&owner=123@qq.com&pre=86&phone=15856838232&email=456@qq.com&code=73e59dc6b4e9e080668b8e32f2c7eb3e59dbe20e
import subaccountauth from './routes/subaccountauth'
import CampusRegister from './routes/campus-register';
import bindPhone from './routes/bindPhone.js'
import OAuthGoogle from './routes/OAuthGoogle.js';
import OAuthGithub from './routes/OAuthGithub.js'
import OAuthBjca from './routes/OAuthBjca.js'
import OAuthSenseTime from './routes/OAuthSenseTime.js'
import OAuthUniversal from './routes/OAuthUniversal.js'
import { channelKeys } from './common/channel.js';
import { setChannelKeyFromUrl } from "./common/channel.js"

const channelsRoutes = [];
const Home = (nextState, cb) => {
	require.ensure([], (require) => {
			cb(null, require('./pc/Home.jsx').default)
		}, "home"
	)
}

const ActiveResult = (nextState, cb) => {
	require.ensure([], (require) => {
			cb(null, require('./pc/ActiveResult.jsx').default)
		}, "active-result"
	)
}
// const AccountActive = (nextState, cb) => {
// 	require.ensure([], (require) => {
// 			cb(null, require('./pc/AccountActive.jsx').default)
// 		}, "active"
// 	)
// }

const RetrieveInput = (nextState, cb) => {
	require.ensure([], (require) => {
			cb(null, require('./pc/RetrieveInput.js').default)
		}, "retrieve-input"
	)
}

const ActiveSubaccount = (nextState, cb) => {
	require.ensure([], (require) => {
			cb(null, require('./pc/ActiveSubaccount.jsx').default)
		}, "activeSubaccount"
	)
}
const SubAccountLogin = (nextState, cb) => {
	require.ensure([], (require) => {
			cb(null, require('./pc/SubAccountLogin.jsx').default)
		}, "subAccountLogin"
	)
}
// 注意：依靠主站和ucloud主站，需要配置此路由，否则无法访问子账号登录页面
// const channelKeys2 = 'ch_xmtzkj_pbwxi6tlniwdcnjq|ch_krx_nnzhqlbrgy3a|ch_lskj_nrzww2rmge3tq|ch_wwjl_o53wu3bmge2ti|ch_nskj_nzzww2rmge4tg|ch_jxcx_nj4gg6bmgiydc|ch_yika_pfuwwyjmgiydg|ch_bjqj_mjvhc2rmgiydk'
if(channelKeys){
	channelKeys.split("|").forEach((channelKey) => {
		const items = [];
		items.push({ path : `/${channelKey}`, getComponent: Home })
		items.push({ path : `/${channelKey}/login`, getComponent: Home })
		items.push({ path : `/${channelKey}/register`, getComponent: Home })
		// items.push({ path : `/${channelKey}/active`, getComponent: AccountActive })
		items.push({ path : `/${channelKey}/activeResult`, getComponent: ActiveResult })
		items.push({ path : `/${channelKey}/retrieveInput`, getComponent: RetrieveInput })
		items.push({ path : `/${channelKey}/activeSubaccount`, getComponent: ActiveSubaccount })
		items.push({ path : `/${channelKey}/login/subAccount(/:subid)`, getComponent: SubAccountLogin })
		channelsRoutes.push(...items);
	})
}

var route = {
	path: '/',
	// components   : Home,
	indexRoute: {
		getComponent(nextState, cb) {
			require.ensure(
				[],
				(require) => {
					cb(null, require('./pc/Home.jsx').default)
				},
				'home'
			)
		},
	},
	childRoutes: [
		...channelsRoutes,
		loginRoute,
		SubAccountLoginRoute,
		registerRoute,
		activeRoute,
		activeResultRoute,
		retrieve,
		retrieveInput,
		retrieveByMobile,
		verifyPhoneNumber,
		resetPassword,
		loginRouteOld,
		registerRouteOld,
		OAuth,
		Logout,
		Guide,
		ChangePwdTermly,
		activeSubaccount,
		subaccountauth,
		CampusRegister,
        bindPhone,
        OAuthGoogle,
        OAuthGithub,
		OAuthBjca,
		OAuthSenseTime,
		OAuthUniversal,
		{
			path: "/*",
			getComponent(nextState, cb) {
				require.ensure(
					[],
					(require) => {
						cb(null, require('./pc/Redirect.jsx').default)
					},
					'redirect'
				)
			},
		}
	],
}

export default route



// WEBPACK FOOTER //
// ./src/route.js